import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { of, Subject } from 'rxjs';
import { SubscriptionWithDestroyTriggerComponent } from 'src/app/subscription-helpers/subscription-with-destroy-trigger.component';
import { ClientCornerHomePageCompletedSubProjectsControllerRequestService } from './service/client-corner-home-page-completed-subprojects-controller-request.service';
import {
  ClientCornerHomePageCompletedSubProjectsHelper,
  CompletedSubProjectItem,
} from './helper/client-corner-home-page-completed-subprojects-helper';
import { catchError, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { SubProject } from 'src/app/model/project/sub-project';
import { GeneralHelper } from 'src/app/helpers/general-helper';

@Component({
  selector: 'client-corner-home-page-completed-subprojects',
  templateUrl: './client-corner-home-page-completed-subprojects.component.html',
  styleUrls: ['./client-corner-home-page-completed-subprojects.component.scss'],
})
export class ClientCornerHomePageCompletedSubProjectsComponent
  extends SubscriptionWithDestroyTriggerComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input()
  selectedCompanyId: number;

  completedSubProjectItems: CompletedSubProjectItem[];

  loading: boolean = false;
  fetchCompletedSubProjectsSubject = new Subject<any>();

  constructor(
    private clientCornerHomePageCompletedSubProjectsControllerRequestService: ClientCornerHomePageCompletedSubProjectsControllerRequestService
  ) {
    super();
  }

  ngOnInit(): void {
    this.addSubscription(
      this.fetchCompletedSubProjectsSubject.pipe(
        startWith([]),
        switchMap(async () => {
          this.loading = true;
          return this.selectedCompanyId == null
            ? null
            : await this.clientCornerHomePageCompletedSubProjectsControllerRequestService.completedSubProjects(
                this.selectedCompanyId
              );
        }),
        catchError(() => of([])),
        takeUntil(this.destroyThisComponent)
      ),
      (subProjects: SubProject[]) => {
        this.completedSubProjectItems =
          ClientCornerHomePageCompletedSubProjectsHelper.processSubProjects(
            subProjects
          );
        this.loading = false;
      }
    );
    this.fetchCompletedSubProjectsSubject.next();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.selectedCompanyId) {
      if (this.completedSubProjectItems != null) {
        this.completedSubProjectItems.length = 0;
      }
      this.fetchCompletedSubProjectsSubject.next();
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.fetchCompletedSubProjectsSubject != null) {
      this.fetchCompletedSubProjectsSubject.complete();
    }
  }

  trackById(index: number, obj: CompletedSubProjectItem): number {
    return GeneralHelper.trackById(index, obj);
  }
}
